import React, { CSSProperties } from 'react';
import { i18n_new_class_meditation_chip } from '@yi/i18n/phrases/i18n_new_class_meditation_chip';

import { useLocale } from '~/src/components/LocaleProvider';

import { Chip } from './elements';

export const CardNewChip: React.FC<{
  className?: string;
  style?: CSSProperties | undefined;
}> = props => {
  const { locale } = useLocale();

  return (
    <Chip aria-label="recently published content item chip" {...props}>
      {i18n_new_class_meditation_chip(locale)}
    </Chip>
  );
};
